import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';
import { SelectInput } from 'components/Common/Inputs';

// eslint-disable-next-line react/prefer-stateless-function
export class FormTypeSelect extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    required: PropTypes.bool,
    validate: PropTypes.func,
    value: PropTypes.string,
    showAllForms: PropTypes.bool,
    entity: PropTypes.bool,
    individual: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    showCrsFormTypes: PropTypes.bool,
    showFatcaCrsFormTypes: PropTypes.bool,
    showWFormTypes: PropTypes.bool,
    usNonUsGiven: PropTypes.bool,
    usPerson: PropTypes.bool,
    addImyLayer: PropTypes.bool,
    beneficiaryForms: PropTypes.bool,
    formtypes: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    })),
  };

  static defaultProps = {
    required: false,
    validate: () => {},
    showAllForms: true,
    value: null,
    showCrsFormTypes: false,
    showFatcaCrsFormTypes: false,
    showWFormTypes: false,
    entity: false,
    individual: false,
    usNonUsGiven: false,
    usPerson: false,
    addImyLayer: false,
    beneficiaryForms: false,
    formtypes: []
  };

  licensed(optionFormType) {
    const { formtypes } = this.props;

    for (let i = 0; i < formtypes.length; i += 1) {
      if (formtypes[i].key === optionFormType) {
        return true;
      }
    }
    return false;
  }

  render() {
    const {
      id,
      name,
      className,
      required,
      validate,
      value,
      showAllForms,
      entity,
      individual,
      showCrsFormTypes,
      showFatcaCrsFormTypes,
      showWFormTypes,
      usNonUsGiven,
      usPerson,
      addImyLayer,
      beneficiaryForms,
      onChange
    } = this.props;

    return (
      <Field
        id={ id }
        name={ name }
        component={ SelectInput }
        className={ className }
        required={ required }
        hideHints
        validate={ validate }
        value={ value }
        onChange={ (e, newValue) => onChange(e, newValue) }
      >
        <option value="">Choose a form type</option>
        { this.licensed('crse') && showCrsFormTypes && (showAllForms || entity) && <option value="crse">CRS-E 2017</option> }
        { this.licensed('dt_crse') && showCrsFormTypes && (showAllForms || entity) && <option value="dt_crse">Deloitte CRS-E</option> }
        { this.licensed('crscp') && showCrsFormTypes && (showAllForms || entity) && <option value="crscp">CRS-CP 2017</option> }
        { this.licensed('dt_crscp') && showCrsFormTypes && (showAllForms || entity) && <option value="dt_crscp">Deloitte CRS-CP</option> }
        { this.licensed('crsi') && showCrsFormTypes && (showAllForms || individual) && <option value="crsi">CRS-I 2017</option> }
        { this.licensed('crsi_2024') && showCrsFormTypes && (showAllForms || individual) && <option value="crsi_2024">CRS-I 2024</option> }
        { this.licensed('rc518') && showCrsFormTypes && (showAllForms || individual) && <option value="rc518">RC518 2023</option> }
        { this.licensed('rc519') && showCrsFormTypes && (showAllForms || entity) && <option value="rc519">RC519 2023</option> }
        {this.licensed('rc518_2024') && showCrsFormTypes && (showAllForms || individual) && <option value="rc518_2024">RC518 2024</option>}
        {this.licensed('rc519_2024') && showCrsFormTypes && (showAllForms || entity) && <option value="rc519_2024">RC519 2024</option>}
        { this.licensed('dt_crsi') && showCrsFormTypes && (showAllForms || individual) && <option value="dt_crsi">Deloitte CRS-I</option> }
        { this.licensed('fatca_crse_2022') && showFatcaCrsFormTypes && (showAllForms || entity) && <option value="fatca_crse_2022">FATCA CRS-E Jul-2022</option> }
        { this.licensed('fatca_crse_2023') && showFatcaCrsFormTypes && (showAllForms || entity) && <option value="fatca_crse_2023">FATCA CRS-E May-2023</option>}
        { this.licensed('fatca_crsi_2022') && showFatcaCrsFormTypes && (showAllForms || individual) && <option value="fatca_crsi_2022">FATCA CRS-I Jun-2022</option> }
        { this.licensed('fatca_crsi_2023') && showFatcaCrsFormTypes && (showAllForms || individual) && <option value="fatca_crsi_2023">FATCA CRS-I May-2023</option> }
        { this.licensed('w8bene') && showWFormTypes && (showAllForms || (entity && !usPerson)) && <option value="w8bene">W-8BEN-E Apr-2016</option> }
        { this.licensed('w8bene_2017') && showWFormTypes && (showAllForms || (entity && !usPerson)) && <option value="w8bene_2017">W-8BEN-E Jul-2017</option> }
        { this.licensed('w8bene_2021') && showWFormTypes && (showAllForms || (entity && !usPerson)) && <option value="w8bene_2021">W-8BEN-E Oct-2021</option> }
        { this.licensed('w8ben_2014') && showWFormTypes && (showAllForms || (individual && (!usNonUsGiven || !usPerson))) && <option value="w8ben_2014">W-8BEN Feb-2014</option> }
        { this.licensed('w8ben') && showWFormTypes && (showAllForms || (individual && (!usNonUsGiven || !usPerson))) && <option value="w8ben">W-8BEN Jul-2017</option> }
        { this.licensed('w8ben_2021') && showWFormTypes && (showAllForms || (individual && (!usNonUsGiven || !usPerson))) && <option value="w8ben_2021">W-8BEN Oct-2021</option> }
        { this.licensed('w8eci_2014') && showWFormTypes && (showAllForms || ((individual || entity) && !usPerson)) && <option value="w8eci_2014">W-8ECI Feb-2014</option> }
        { this.licensed('w8eci') && showWFormTypes && (showAllForms || ((individual || entity) && !usPerson)) && <option value="w8eci">W-8ECI Jul-2017</option> }
        { this.licensed('w8eci_2021') && showWFormTypes && (showAllForms || ((individual || entity) && !usPerson)) && <option value="w8eci_2021">W-8ECI Oct-2021</option> }
        { this.licensed('w8exp_2016') && showWFormTypes && (showAllForms || (entity && !usPerson)) && <option value="w8exp_2016">W-8EXP Sep-2016</option> }
        { this.licensed('w8exp') && showWFormTypes && (showAllForms || (entity && !usPerson)) && <option value="w8exp">W-8EXP Jul-2017</option> }
        { this.licensed('w8exp_2023') && showWFormTypes && (showAllForms || (entity && !usPerson)) && <option value="w8exp_2023">W-8EXP Oct-2023</option>}
        { this.licensed('w8imy') && showWFormTypes && (showAllForms || (addImyLayer || (entity && !usPerson))) && <option value="w8imy">W-8IMY Sep-2016</option> }
        { this.licensed('w8imy_2017') && showWFormTypes && (showAllForms || (addImyLayer || (entity && !usPerson))) && <option value="w8imy_2017">W-8IMY Jun-2017</option> }
        { this.licensed('w8imy_2021') && showWFormTypes && (showAllForms || (addImyLayer || (entity && !usPerson))) && <option value="w8imy_2021">W-8IMY Oct-2021</option> }
        { this.licensed('w9') && showWFormTypes && (showAllForms || ((individual || entity) && (!usNonUsGiven || usPerson))) && <option value="w9">W-9 Dec-2014</option> }
        { this.licensed('w9_2017') && showWFormTypes && (showAllForms || ((individual || entity) && (!usNonUsGiven || usPerson))) && <option value="w9_2017">W-9 Nov-2017</option> }
        { this.licensed('w9_2018') && showWFormTypes && (showAllForms || ((individual || entity) && (!usNonUsGiven || usPerson))) && <option value="w9_2018">W-9 Oct-2018</option> }
        { this.licensed('w9_2024') && showWFormTypes && (showAllForms || ((individual || entity) && (!usNonUsGiven || usPerson))) && <option value="w9_2024">W-9 Mar-2024</option> }
        { this.licensed('w8bene') && beneficiaryForms && <option value="w8bene">W-8BEN-E Apr-2016</option> }
        { this.licensed('w8bene_2017') && beneficiaryForms && <option value="w8bene_2017">W-8BEN-E Jul-2017</option> }
        { this.licensed('w8bene_2021') && beneficiaryForms && <option value="w8bene_2021">W-8BEN-E Oct-2021</option> }
        { this.licensed('w8ben_2014') && beneficiaryForms && <option value="w8ben_2014">W-8BEN Feb-2014</option> }
        { this.licensed('w8ben') && beneficiaryForms && <option value="w8ben">W-8BEN Jul-2017</option> }
        { this.licensed('w8ben_2021') && beneficiaryForms && <option value="w8ben_2021">W-8BEN Oct-2021</option> }
        { this.licensed('w8eci_2014') && beneficiaryForms && <option value="w8eci_2014">W-8ECI Feb-2014</option> }
        { this.licensed('w8eci') && beneficiaryForms && <option value="w8eci">W-8ECI Jul-2017</option> }
        { this.licensed('w8eci_2021') && beneficiaryForms && <option value="w8eci_2021">W-8ECI Oct-2021</option> }
        { this.licensed('w8exp_2016') && beneficiaryForms && <option value="w8exp_2016">W-8EXP Sep-2016</option> }
        { this.licensed('w8exp') && beneficiaryForms && <option value="w8exp">W-8EXP Jul-2017</option> }
        { this.licensed('w8exp_2023') && beneficiaryForms && <option value="w8exp_2023">W-8EXP Oct-2023</option> }
        { this.licensed('w9') && beneficiaryForms && <option value="w9">W-9 Dec-2014</option> }
        { this.licensed('w9_2017') && beneficiaryForms && <option value="w9_2017">W-9 Nov-2017</option> }
        { this.licensed('w9_2018') && beneficiaryForms && <option value="w9_2018">W-9 Oct-2018</option> }
        { this.licensed('w9_2024') && beneficiaryForms && <option value="w9_2024">W-9 Mar-2024</option> }
      </Field>
    );
  }
}

// Compose FormTypeSelect component with redux
function mapStateToProps(state) {
  const {
    auth: {
      settings: {
        formtypes
      }
    }
  } = state;

  return {
    formtypes,
  };
}

export default connect(
  mapStateToProps
)(FormTypeSelect);
